import React from 'react';
import { CSVLink } from 'react-csv';
import { useQuery } from '@apollo/client';
import { getItemsByOwner } from '../api';

interface Props {
  owner: any;
}

export const FinalReportButton = (props: Props) => {
  const { data, loading, error } = useQuery(getItemsByOwner, {
    variables: {
      owner: String(props.owner.PhysicalOwner),
    },
  });

  if (loading) return <div>Generating FinalReport...</div>;
  if (error) return <div>{JSON.stringify(error)}</div>;

  return (
    <CSVLink data={data.assetsByOwner} filename={`reportFor_${props.owner.PhysicalOwner}${new Date()}.csv`}>
      Download Final Report
    </CSVLink>
  );
};
